module.exports = __webpack_public_path__ + "img/bbjw3.a45aab2a.jpg";